angular.module('core')
.controller('GraduateConfirmationModalController', ['$scope', '$modalInstance', function($scope, $modalInstance){
    $scope.yes = function() {
        $modalInstance.close();
    };

    $scope.no = function() {
        $modalInstance.dismiss('cancel');
    };
}]);
